import Api from './Api';

export default class MunicipiosApi {

    all = async () => {
        return await Api.get('/municipios').then(response => {
            return response.data;
        }).catch((error) => console.log('[MUNICIPIOSAPI.ALL]: Error\n', error));
    }

    find = async (_id) => {
        return await Api.get(`/municipios/${_id}`).then(response => {
            return response.data;
        }).catch((error) => console.log('[MUNICIPIOSAPI.ID]: Error\n', error));
    }

    populacaoAproximada =async (_id, _tolerancia) => {
        return await Api.get(`/municipios/${_id}/populacao/aproximada/${_tolerancia}`).then(response => {
            return response.data;
        }).catch((error) => console.log('[MUNICIPIOSAPI.POPULACAOAPROXIMADA]: Error\n', error));
    }

}